import {
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_LIST_FAIL,
  PRODUCT_LIST_RESET,
  PRODUCT_STATS_REQUEST,
  PRODUCT_STATS_SUCCESS,
  PRODUCT_STATS_FAIL,
  PRODUCT_STATS_RESET,
  PRODUCT_SINGLE_REQUEST,
  PRODUCT_SINGLE_SUCCESS,
  PRODUCT_SINGLE_FAIL,
  PRODUCT_SINGLE_RESET,
  PRODUCT_PER_SERVICE_REQUEST,
  PRODUCT_PER_SERVICE_SUCCESS,
  PRODUCT_PER_SERVICE_FAIL,
  PRODUCT_PER_SERVICE_RESET,
  CREATE_PRODUCT_REQUEST,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAIL,
  CREATE_PRODUCT_RESET,
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAIL,
  UPDATE_PRODUCT_RESET,
  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAIL,
  DELETE_PRODUCT_RESET,
} from "constants/productConstants";

export const listProductsReducer = (state = { productsList: [] }, action) => {
  switch (action.type) {
    case PRODUCT_LIST_REQUEST:
      return { loading: true };
    case PRODUCT_LIST_SUCCESS:
      return { loading: false, productsList: action.payload, success: true };
    case PRODUCT_LIST_FAIL:
      return { loading: false, error: action.payload };
    case PRODUCT_LIST_RESET:
      return [];
    default:
      return state;
  }
};

export const statsProductsReducer = (state = { productsStats: [] }, action) => {
  switch (action.type) {
    case PRODUCT_STATS_REQUEST:
      return { loading: true };
    case PRODUCT_STATS_SUCCESS:
      return { loading: false, productsStats: action.payload, success: true };
    case PRODUCT_STATS_FAIL:
      return { loading: false, error: action.payload };
    case PRODUCT_STATS_RESET:
      return { productsStats: [] };
    default:
      return state;
  }
};

export const singleProductReducer = (state = { productSingle: {} }, action) => {
  switch (action.type) {
    case PRODUCT_SINGLE_REQUEST:
      return { loading: true };
    case PRODUCT_SINGLE_SUCCESS:
      return { loading: false, productSingle: action.payload, success: true };
    case PRODUCT_SINGLE_FAIL:
      return { loading: false, error: action.payload };
    case PRODUCT_SINGLE_RESET:
      return { productSingle: {} };
    default:
      return state;
  }
};

export const listProductsPerServiceReducer = (
  state = { productsListPerService: [] },
  action
) => {
  switch (action.type) {
    case PRODUCT_PER_SERVICE_REQUEST:
      return { loading: true };
    case PRODUCT_PER_SERVICE_SUCCESS:
      return {
        loading: false,
        productsListPerService: action.payload,
        success: true,
      };
    case PRODUCT_PER_SERVICE_FAIL:
      return { loading: false, error: action.payload };
    case PRODUCT_PER_SERVICE_RESET:
      return [];
    default:
      return state;
  }
};

export const createProductReducer = (state = { productCreate: {} }, action) => {
  switch (action.type) {
    case CREATE_PRODUCT_REQUEST:
      return { loading: true };
    case CREATE_PRODUCT_SUCCESS:
      return { loading: false, productCreate: action.payload, success: true };
    case CREATE_PRODUCT_FAIL:
      return { loading: false, error: action.payload };
    case CREATE_PRODUCT_RESET:
      return { productCreate: {} };
    default:
      return state;
  }
};

export const updateProductReducer = (state = { productUpdate: {} }, action) => {
  switch (action.type) {
    case UPDATE_PRODUCT_REQUEST:
      return { loading: true };
    case UPDATE_PRODUCT_SUCCESS:
      return { loading: false, productUpdate: action.payload, success: true };
    case UPDATE_PRODUCT_FAIL:
      return { loading: false, error: action.payload };
    case UPDATE_PRODUCT_RESET:
      return { productUpdate: {} };
    default:
      return state;
  }
};

export const deleteProductReducer = (state = { productDelete: {} }, action) => {
  switch (action.type) {
    case DELETE_PRODUCT_REQUEST:
      return { loading: true };
    case DELETE_PRODUCT_SUCCESS:
      return { loading: false, productDelete: action.payload, success: true };
    case DELETE_PRODUCT_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_PRODUCT_RESET:
      return { productDelete: {} };
    default:
      return state;
  }
};
